<template>
    <div class="lms__superadmin_users_bulk_actions_cancel_invitations">
        <div class="lms__superadmin_users_bulk_actions_cancel_invitations_header">
            <view-actions
                :title="'Cancel invitations'"
                :custom-notify-active="false"
                :cancel-button-active="currentRouteName !== 'lms-superadmin-user-bulk-actions-cancel-invitations-summary'"
                :cancel-button-text="'Cancel'"
                :cancel-notify-active="false"
                :submit-button-active="true"
                :submit-button-disabled="nextButtonDisabled"
                :submit-button-text="nextButtonText"
                @emit-cancel="stopAddUsers"
                @emit-submit="handleRedirect"
            />
        </div>
        <div class="lms__superadmin_users_bulk_actions_cancel_invitations_main">
            <div class="container fullheight">
                <div class="columns is-block-mobile fullheight m-t-b-0">
                    <div class="column is-narrow p-t-b-0">
                        <component-sidebar
                            :tour-active="true"
                            :nav-items="[
                                {
                                    label: 'Select users',
                                    name: 'lms-superadmin-user-bulk-actions-cancel-invitations-select-users',
                                    prevent: currentRouteName === 'lms-superadmin-user-bulk-actions-cancel-invitations-summary'
                                },
                                {
                                    label: 'Preview',
                                    name: 'lms-superadmin-user-bulk-actions-cancel-invitations-preview',
                                    prevent: currentRouteName === 'lms-superadmin-user-bulk-actions-cancel-invitations-summary'
                                },
                                {
                                    label: 'Summary',
                                    name: 'lms-superadmin-user-bulk-actions-cancel-invitations-summary',
                                    prevent: currentRouteName === 'lms-superadmin-user-bulk-actions-cancel-invitations-summary'
                                }
                            ]"
                        ></component-sidebar>
                    </div>
                    <div class="column p-t-b-0">
                        <section class="lms__superadmin_users_bulk_actions_cancel_invitations_main_content">
                            <keep-alive>
                                <transition name="fade" mode="out-in">
                                    <router-view/>
                                </transition>
                            </keep-alive>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import ComponentSidebar from '@/components/default/shared/ComponentSidebar'

export default {
  name: 'lms-superadmin-users-bulk-actions-cancel-invitations',
  components: { ComponentSidebar, ViewActions },
  computed: {
    bulkActionPending () {
      return this.$store.getters.getLmsSuperadminUsersBulkActionsCancelInvitationsActionPending
    },
    nextButtonText () {
      let text

      if (this.currentRouteName === 'lms-superadmin-user-bulk-actions-cancel-invitations-preview') {
        text = 'Cancel invitations'
      } else if (this.currentRouteName === 'lms-superadmin-user-bulk-actions-cancel-invitations-summary') {
        text = 'Finish'
      } else {
        text = 'Next'
      }

      return text
    },
    nextButtonDisabled () {
      let disabled = false

      if (
        (this.currentRouteName === 'lms-superadmin-user-bulk-actions-cancel-invitations-summary' && this.bulkActionPending) ||
        (!this.selectedUsersProfileIds.length)
      ) {
        disabled = true
      }

      return disabled
    },
    currentRouteName () {
      return this.$route.name
    },
    selectedUsersProfileIds () {
      return this.$store.getters.getLmsSuperadminUsersBulkActionsCancelInvitationsItemsProfileIds
    },
    backToUsers () {
      return { name: 'lms-superadmin-user-list' }
    }
  },
  methods: {
    stopAddUsers () {
      this.$router.push({ name: 'lms-superadmin-user-list' })
    },
    handleRedirect () {
      let redirectTo

      if (this.currentRouteName === 'lms-superadmin-user-bulk-actions-cancel-invitations-select-users') {
        redirectTo = 'lms-superadmin-user-bulk-actions-cancel-invitations-preview'
      } else if (this.currentRouteName === 'lms-superadmin-user-bulk-actions-cancel-invitations-preview') {
        redirectTo = 'lms-superadmin-user-bulk-actions-cancel-invitations-summary'
      } else if (this.currentRouteName === 'lms-superadmin-user-bulk-actions-cancel-invitations-summary') {
        this.clearData()
        redirectTo = 'lms-superadmin-user-list'
      }

      this.$router.push({ name: redirectTo })
    },
    clearData () {
      this.$store.dispatch('lmsSuperadminUsersBulkActionsCancelInvitationsClear')
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/users/_lmssuperadminusersbulkactionscancelinvitations.scss";
</style>
